// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SharedUpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel {
    static getAttributeTypeMap() {
        return SharedUpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel.attributeTypeMap;
    }
}
SharedUpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel.discriminator = undefined;
SharedUpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel.additionalProperties = false;
SharedUpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel.attributeTypeMap = [
    {
        "name": "canUpdate",
        "baseName": "canUpdate",
        "type": "boolean"
    },
    {
        "name": "canInsert",
        "baseName": "canInsert",
        "type": "boolean"
    },
    {
        "name": "skipSearch",
        "baseName": "skipSearch",
        "type": "boolean"
    },
    {
        "name": "model",
        "baseName": "model",
        "type": "EnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel"
    },
];
//# sourceMappingURL=sharedUpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel.js.map